import { CSVTableRowProps } from 'types';
import { Disabled, Input } from './styles';

const FillNanValueRow = ({ rowIndex, columnLabels, isEditMode, values, useFormReturn }: CSVTableRowProps) => {
  const { register, setValue, watch } = useFormReturn;
  const isNanFill = watch('nan') === 'fill';

  if (isEditMode) {
    return (
      <tr>
        <th>결측치 값</th>
        <td>
          {!isNanFill ? (
            <Disabled />
          ) : (
            <Input
              {...register('allFillNanValue', {
                onChange: (event) => {
                  setValue(
                    'fillNanValues',
                    values.map(() => event.currentTarget.value)
                  );
                },
              })}
              placeholder={'value'}
            />
          )}
        </td>
        {columnLabels.map((label, i) => (
          <td key={`col${label}_row${rowIndex}_edit`}>
            {values?.[i] !== undefined &&
              (!isNanFill ? <Disabled /> : <Input {...register(`fillNanValues.${i}`)} placeholder={'value'} />)}
          </td>
        ))}
      </tr>
    );
  }

  return (
    <tr>
      <th>{rowIndex}</th>
      {columnLabels.map((label, i) => (
        <td key={`col/${label}/row/${rowIndex}`}></td>
      ))}
    </tr>
  );
};

export default FillNanValueRow;
